import { api } from '../api/client';
import { User } from '../types';

export const getAllUsers = async (): Promise<User[]> => {
  return api.get<User[]>('/users');
};

export const createUser = async (
  email: string,
  password: string,
  displayName: string,
  role: 'admin' | 'store_manager'
): Promise<User> => {
  return api.post<User>('/users', { email, password, displayName, role });
};

export const updateUser = async (
  id: string,
  changes: { displayName?: string; role?: 'admin' | 'store_manager'; isActive?: boolean }
): Promise<User> => {
  return api.patch<User>(`/users/${id}`, changes);
};

export const changeUserPassword = async (id: string, password: string): Promise<void> => {
  await api.post(`/users/${id}/password`, { password });
};

export const deleteUser = async (id: string): Promise<void> => {
  await api.delete(`/users/${id}`);
};
